__webpack_require__.p = "https://app.groovehq.com/app-release/";